const check_gift_product = document.querySelector('body').classList.contains('product-gift-cards');
if (check_gift_product) {
      customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
        constructor() {
            super(),
            this.selectors = {
                form: "form",
                inputId: "[name=id]",
                submitButton: '[name="add"]',
                errorWrapper: ".f-product-form__error-message-wrapper",
                customFields: ["[data-product-custom-field]"]
            },
            this.domNodes = queryDomNodes(this.selectors, this),
            this.form = this.domNodes.form,
            this.submitButton = this.domNodes.submitButton,
            this.domNodes.inputId.disabled = !1,
            this.Notification = window.FoxTheme.Notification,
            this.notificationType = this.dataset.notificationType,
            this.customFields = document.querySelectorAll(this.selectors.customFields),
            this.cartDrawer = document.querySelector("cart-drawer"),
            this.mainCart = document.querySelector("cart-items"),
            this.type = this.dataset.type,
            this.errorWrapper = this.type === "product-card" ? this.closest(".product-card") : this.domNodes.errorWrapper,
            this.form && this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        }
        validateForm(form) {
            const missingFields = [];
            return form && form.querySelectorAll('[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])').forEach(field => {
                if (field.classList.remove("form-control--warning"),
                field.type === "radio") {
                    const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
                    Array.from(buttons).some(btn => btn.checked) || (missingFields.push(field),
                    field.classList.add("form-control--warning"))
                } else
                    field.value || (missingFields.push(field),
                    field.classList.add("form-control--warning"))
            }
            ),
            missingFields
        }
        onSubmitHandler(evt) {
            var activeVarValue = document.querySelector(".variant-picker__input input[type=radio]:checked").value;
            if (activeVarValue == "By the Yard") {
                var yard_qunty = $(document).find(".yard_qty").val();
                $(document).find(".selected_yard_count").val(yard_qunty)
            }
            evt.preventDefault();
            const missing = this.validateForm(this.form.closest(".f-product-single__blocks"));
            if (missing && missing.length > 0)
                return this.Notification.show({
                    target: this.domNodes.errorWrapper,
                    method: "appendChild",
                    type: "warning",
                    message: window.FoxThemeStrings.requiredField
                });
            if (this.submitButton.classList.contains("btn--loading"))
                return;
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButton.classList.add("btn--loading");
            const config = {
                method: "POST",
                headers: {
                    Accept: "application/javascript",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
              , formData = new FormData(this.form);
            this.cartDrawer && formData.append("sections", this.cartDrawer.getSectionsToRender().map(section => section.id)),
            this.mainCart && formData.append("sections", this.mainCart.getSectionsToRender().map(section => section.section)),
            (this.mainCart || this.cartDrawer) && formData.append("sections_url", window.location.pathname),
            config.body = formData;
            const {FoxThemeSettings, FoxThemeStrings} = window;
            fetch(`${FoxThemeSettings.routes.cart_add_url}`, config).then(response => response.json()).then(response => {
                if (response.status) {
                    window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        errors: response.description,
                        message: response.message
                    }),
                    this.error = !0;
                    var inventroy_qunty = $(document).find(".itemQytParts").data("qytparts");
                    let nesmess = (response.description || response.message) + " Available yard (" + inventroy_qunty + ")";
                    return this.Notification.show({
                        target: this.notificationType === "toast" ? document.body : this.errorWrapper,
                        method: "appendChild",
                        type: "warning",
                        message: nesmess,
                        last: 5e3,
                        sticky: this.notificationType === "toast"
                    })
                }
                (!FoxThemeSettings.cart.openDrawerWhenAdded || FoxThemeSettings.cart.cartType === "page") && this.Notification.show({
                    target: this.errorWrapper,
                    method: "appendChild",
                    type: "success",
                    message: FoxThemeStrings.item_added,
                    last: 3e3,
                    sticky: this.notificationType === "toast"
                }),
                FoxThemeSettings.cart.cartType === "page" && FoxThemeCartHelpers.getState().then(state => {
                    FoxThemeCartHelpers.updateCartCount(state.item_count)
                }
                ),
                this.error = !1,
                window.FoxThemeEvents.emit("ON_ITEM_ADDED", response),
                location.pathname = "/cart"
            }
            ).catch(e => {
                console.error(e)
            }
            ).finally( () => {
                this.submitButton.classList.remove("btn--loading"),
                this.submitButton.removeAttribute("aria-disabled")
            }
            )
        }
    }
  );
 } else {
    if (!customElements.get('product-form')) {
    	customElements.define('product-form', class ProductForm extends HTMLElement {
    	constructor() {
        super()
        this.selectors = {
            form: 'form',
            inputId: '[name=id]',
            submitButton: '[name="add"]',
            errorWrapper: '.f-product-form__error-message-wrapper',
            customFields: ['[data-product-custom-field]']
        }
    
        this.domNodes = queryDomNodes(this.selectors, this)
        this.form = this.domNodes.form
        this.submitButton = this.domNodes.submitButton
        this.domNodes.inputId.disabled = false
        this.Notification = window.FoxTheme.Notification
        this.notificationType = this.dataset.notificationType
        this.customFields = document.querySelectorAll(this.selectors.customFields)
        this.cartDrawer = document.querySelector('cart-drawer')
        this.mainCart = document.querySelector('cart-items')
        this.type = this.dataset.type
        this.errorWrapper = this.type === 'product-card' ? this.closest('.product-card') : this.domNodes.errorWrapper
    
        if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        }
    }
    
      async validateCartStock(variantId, requestedQty, availableStock) {
          try {
              let cartResponse = await fetch('/cart.js');
              let cart = await cartResponse.json();
              let cartQty = 0;
              let itemFound = false;
              cart.items.forEach(item => {
                  if (item.variant_id == variantId) {
                      cartQty = item.quantity;
                      itemFound = true;
                  }
              });
      
              let totalQty = cartQty + requestedQty;
              var customer_enter_andcart_main = availableStock - cartQty;
              var customer_enter_andcart = customer_enter_andcart_main / 4;
            
              if (totalQty > availableStock) {
                var check_quantity = document.querySelector('#Quantity_custom');
                if (check_quantity) {
                  var add_btn = document.querySelector('button[type="submit"][name="add"]');
                  if (add_btn) {
                    add_btn.setAttribute('aria-disabled', false);
                    add_btn.classList.remove('btn--loading');
                  }
                  return { isValid: false, errorMessage: `Maximum Quantity Available: (${customer_enter_andcart})` };
                } else {
                   var add_btn = document.querySelector('button[type="submit"][name="add"]');
                    if (add_btn) {
                      add_btn.setAttribute('aria-disabled', false);
                      add_btn.classList.remove('btn--loading');
                    }
                   return { isValid: false, errorMessage: `Maximum Quantity Available: (${customer_enter_andcart_main})` };
                }
              }
              return { isValid: true };
          } catch (error) {
             // return { isValid: false, errorMessage: "Error checking stock. Please try again." };
          }
      }
  
      async onSubmitHandler(evt) {
          evt.preventDefault(); 
          let activeVarValue = document.querySelector('.variant-picker__input input[type=radio]:checked')?.value;
        
          if (activeVarValue === "By the Yard" || activeVarValue === "By the Panel") {
              let yardQty = document.querySelector('.yard_qty')?.value;
              document.querySelector('.selected_yard_count')?.setAttribute('value', yardQty);
          }
  
          if (this.submitButton.classList.contains('btn--loading')) return;
      
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('btn--loading');
      
          let availableStock = parseInt(document.querySelector('.old_qty_box')?.getAttribute('data-quantity')) || 0;
          let requestedQty = parseInt(document.querySelector('.old_qty_box')?.value) || 1;
        
          var variantId = document.querySelector('.CustomSampleVariantId')?.value;
          if (!variantId) {
            var variantId = document.querySelector('.main-product-form input[name="id"]')?.value;
          }
  
          var check_continue = document.querySelector('.old_qty_box')?.getAttribute('data-continuesell');
          var this_ = this;
          if (!document.body.classList.contains("template-collection")) {
        //  console.log("Body has the class!");
          if (check_continue != 'on') {
            //  console.log(availableStock);
            // console.log(requestedQty)
            // console.log(variantId)
            let stockValidation = await this_.validateCartStock(variantId, requestedQty, availableStock);
            if (!stockValidation.isValid) {
                this_.Notification.show({
                    target: this.errorWrapper,
                    method: 'appendChild',
                    type: 'warning',
                    message: stockValidation.errorMessage,
                    last: 5000
                });
                return;
            }
          }
  
          }
         
          const config = {
              method: 'POST',
              headers: {
                  'Accept': 'application/javascript',
                  'X-Requested-With': 'XMLHttpRequest'
              }
          };
      
          const formData = new FormData(this.form);
      
          if (this.cartDrawer) {
              formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
          }
      
          if (this.mainCart) {
              formData.append('sections', this.mainCart.getSectionsToRender().map((section) => section.section));
          }
      
          if (this.mainCart || this.cartDrawer) {
              formData.append('sections_url', window.location.pathname);
          }
      
          config.body = formData;
          const { FoxThemeSettings, FoxThemeStrings } = window;    
          fetch(`${FoxThemeSettings.routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
                  if (response.status) {
                      let errorMsg = response.description || response.message;
                      let availableQty = document.querySelector('.itemQytParts')?.getAttribute('data-qytparts') || 0;
                      let finalMessage = `${errorMsg} Available item (${availableQty})`;
      
                      return this.Notification.show({
                          target: this.notificationType === 'toast' ? document.body : this.errorWrapper,
                          method: 'appendChild',
                          type: 'warning',
                          message: finalMessage,
                          last: 5000
                      });
                    }
      
                    this.Notification.show({
                        target: this.errorWrapper,
                        method: 'appendChild',
                        type: 'success',
                        message: FoxThemeStrings.item_added,
                        last: 3000
                    });
      
                  window.FoxThemeEvents.emit(`ON_ITEM_ADDED`, response);
                  var _ptitle = document.querySelector('.f-product-single__title').innerText;
                  document.querySelector('.p_title').innerText = _ptitle;
                  document.querySelector('#popupOverlay').style.display = 'block';
                  $("drawer-opener.main_cart_opener[data-drawer='#Drawer-Cart']").load(location.href+" drawer-opener.main_cart_opener[data-drawer='#Drawer-Cart']>*",""); 

            
                //  location.pathname = '/cart';
              }).catch((e) => {
                  console.error(e);
              }).finally(() => {
                  this.submitButton.classList.remove('btn--loading');
                  this.submitButton.removeAttribute('aria-disabled');
              });
      }
  	})
  }
}